import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CitySaintGermainEnLayePage() {
  const data = citiesData.find((c) => c.slug === "saint-germain-en-laye")!;
  return <CityPage data={data} />;
}
